<footer class="lp-footer p-1">
  <div class="d-flex">
    <div class="me-auto lp-footer-text small text-body-secondary">
      <span class="lp-footer-label">
        2026 Agentic CX
        <button
          type="button"
          class="lp-footer-link link-offset-2 link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
          (click)="openAIDisclaimer()">
          {{ '::AiPowered' | abpLocalization }}
        </button>
      </span>
      <br />
    </div>
  </div>
</footer>
